import React, { createContext, useCallback, useContext, useRef } from "react"

type NeedsInfoOpener = () => void

interface NeedsInfoEditorContextValue {
  registerOpener: (opener: NeedsInfoOpener | null) => void
  openNeedsInfoEditor: () => void
}

// No-op default: existing tests render the consumers without the provider.
const noopContextValue: NeedsInfoEditorContextValue = {
  registerOpener: () => {},
  openNeedsInfoEditor: () => {}
}

const NeedsInfoEditorContext =
  createContext<NeedsInfoEditorContextValue>(noopContextValue)

/** Lets the Overview tab and the chip popover open the header's own modal. */
function NeedsInfoEditorProvider({ children }: { children: React.ReactNode }) {
  const openerRef = useRef<NeedsInfoOpener | null>(null)

  const registerOpener = useCallback((opener: NeedsInfoOpener | null) => {
    openerRef.current = opener
  }, [])

  const openNeedsInfoEditor = useCallback(() => {
    openerRef.current?.()
  }, [])

  return (
    <NeedsInfoEditorContext.Provider value={{ registerOpener, openNeedsInfoEditor }}>
      {children}
    </NeedsInfoEditorContext.Provider>
  )
}

function useNeedsInfoEditor() {
  return useContext(NeedsInfoEditorContext)
}

export { NeedsInfoEditorProvider, useNeedsInfoEditor }
